export default __webpack_public_path__ + "static/media/view_note_icon.20748319.svg";